<template>
  <div class="app-main-content">
    <div class="app-main-inner-tab" style="flex-grow:1;display:flex;flex-direction:column;height: 100%;">
      <el-tabs v-model="activeTabName" type="card" style="width:100%;flex-grow:1;height: 100%">
        <el-tab-pane v-if="!isHM" :label="$t('Insurance.FreightInsuranceFirstPage')" name="cargoInsurance">
          <to-insure-page source-from="page" />
        </el-tab-pane>
        <el-tab-pane v-if="checkPermission(['role_cargoInsurance_policyManagement'])" :lazy="true" :label="$t('Insurance.PolicyManagement')" name="policyManagement">
          <policy-grid ref="policyGrid" :insurance-type="1" @changeTab="changeTab" />
        </el-tab-pane>
        <el-tab-pane v-if="!isHM && checkPermission(['role_cargoInsurance_billingManagement'])" :lazy="true" :label="$t('Insurance.BillingManagement')" name="billingManagement">
          <agent-iframe ref="agentIframe" :jump-url="billUrl" :type="'bill'" />
        </el-tab-pane>
        <el-tab-pane v-if="!isHM && checkPermission(['role_cargoInsurance_invoiceManagement'])" :lazy="true" :label="$t('CargoMsg.Cargo_InvoiceInformation')" name="invoiceInformation">
          <agent-iframe :jump-url="invoiceUrl" :type="'invoice'" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import PolicyGrid from '@/views/cargo/v0/Insurance/components/policyGrid'
import ToInsurePage from '@/views/cargo/v0/Insurance/components/toInsurePage'
import { getJumpUrl } from '@/api/external/insureInfo'
import AgentIframe from '@/views/cargo/v0/Insurance/components/agentIframe'
import checkPermission from '@/utils/permission'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'CargoInsurance',
  components: { AgentIframe, PolicyGrid, searchItem, ToInsurePage },
  data() {
    return {
      loading: false,
      activeTabName: 'cargoInsurance',
      insuranceAgent: '',
      billUrl: '',
      invoiceUrl: '',
      isHM: false
    }
  },
  async created() {
    await cache.load(cacheName.USER, cacheName.CONFIG)
    this.isHM = cache.config.get('ToExoSystem') === 'HONGMING'
    if (this.isHM) {
      this.activeTabName = 'policyManagement'
    }
  },
  methods: {
    changeAgent(data) {
      this.insuranceAgent = data
    },
    checkPermission(role) {
      return checkPermission(role)
    },
    async changeTab(type, afUuid, agent) {
      if (type === 'bill') {
        // 查看代理投保单明细
        this.activeTabName = 'billingManagement'
        const data = {
          insuranceAgent: agent,
          branchId: this.$store.getters.currentOfficeId,
          userId: this.$store.getters.userId,
          type: type
        }
        if (afUuid) {
          data.afUuid = afUuid
        }
        await getJumpUrl(data).then(res => {
          if (res.ok) {
            this.billUrl = res.data
          }
        })
        setTimeout(() => {
          this.$refs.agentIframe.insuranceAgent = agent
        }, 100)
      }
    }
  }
}
</script>

<style lang="scss">
</style>

